import { Avatar as AvatarComponent, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"

export const UserAvatar = ({ name, image, className }: { name: string, image?: string, className?: string }) => {
  const initials = name?.split(' ').map(n => n[0]).join('')
  return <AvatarComponent className={cn('h-6 w-6 rounded-xl', className)}>
  <AvatarImage src={image || `https://avatar.vercel.sh/${name}.svg`} alt={name} />
  <AvatarFallback className='rounded-md'>{initials}</AvatarFallback>
</AvatarComponent>
}
